/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomTimePicker from '@/app/customComponents/CustomTimePicker/CustomTimePicker';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import { addSchedule } from '@/app/services/rooms/roomsschedules';
import * as Actions from '@/app/store/actions';
import { getImageUrl } from '@/utils/utils';
import { Avatar, CircularProgress, InputAdornment, TextField } from '@material-ui/core/';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import './roomspage.css';
import PageHeader from '@/app/customComponents/PageHeader';
import { useNavigate } from 'react-router-dom';

const Addschedules = () => {
	const { id } = useParams();
	const [form, setForm] = useState({});
	const dispatch = useDispatch();
	const [selectedFile, setSelectedFile] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [errTxts, setErrTxts] = useState({});
	const [startTime, setStartTime] = useState(null);
	const [endTime, setEndTime] = useState(null);
	const inputRef = useRef(null);
	const [preview, setPreview] = useState(null);
	const navigate = useNavigate();
	const handleChange = (ev) => {
		const { name, value } = ev.target;
		setErrTxts({ ...errTxts, [name]: '' });
		setForm({ ...form, [name]: value });
	};

	const handleTimeChange = (value, name) => {
		setErrTxts({ ...errTxts, [name]: '' });
		setForm({ ...form, [name]: value });
	};

	//

	useEffect(() => {
		if (!selectedFile) {
			setPreview(null);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}

		setSelectedFile(e.target.files[0]);
	};

	const handleSubmit = () => {
		setErrTxts({});
		if (!form.start_time) {
			setErrTxts({ ...errTxts, start_time: 'This field is required' });
			return;
		}
		if (form.start_time < '06:00') {
			setErrTxts({ ...errTxts, start_time: 'Start time should be greater than 06:00 AM' });
			return;
		}
		if (form.start_time > '19:00') {
			setErrTxts({ ...errTxts, start_time: 'Start time should be less than 07:00 PM' });
			return;
		}
		if (!form.end_time) {
			setErrTxts({ ...errTxts, end_time: 'This field is required' });
			return;
		}
		if (form.start_time > form.end_time) {
			setErrTxts({ ...errTxts, end_time: 'End time should be greater than start time' });
			return;
		}
		if (form.end_time < '06:00') {
			setErrTxts({ ...errTxts, end_time: 'End time should be greater than 06:00' });
			return;
		}
		if (form.end_time > '19:00') {
			setErrTxts({ ...errTxts, end_time: 'End time should be less than 19:00' });
			return;
		}
		if (form.end_time < form.start_time) {
			setErrTxts({ ...errTxts, end_time: 'End time should be greater than start time' });
			return;
		}
		if (!form.subject) {
			setErrTxts({ ...errTxts, subject: 'This field is required' });
			return;
		}
		if (form.subject.charAt(0) === ' ' || form.subject.charAt(form.subject.length - 1) === ' ') {
			setErrTxts({ ...errTxts, subject: 'Please enter a valid subject' });
			return;
		}
		if (!form.type) {
			setErrTxts({ ...errTxts, type: 'This field is required' });
			return;
		}
		if (form.type.charAt(0) === ' ' || form.type.charAt(form.type.length - 1) === ' ') {
			setErrTxts({ ...errTxts, type: 'Please enter a valid subject' });
			return;
		}

		if (selectedFile) {
			const filename = getImageUrl(selectedFile);
			setIsLoading(true);
			uploadFile(selectedFile, filename)
				.then((response) => {
					form.photo = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					form.thumb = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					form.room_id = id;
					addSchedule(form)
						.then((resp) => {
							dispatch(
								Actions.showMessage({
									message: resp.data.message,
									autoHideDuration: 1500,
									variant: 'success',
								})
							);
							navigate(-1);
						})
						.catch((err) => {
							if (err.response?.data?.errors) {
								setErrTxts(err.response.data.errors);
							} else {
								dispatch(
									Actions.showMessage({
										message: err.response.data.message,
										autoHideDuration: 1500,
										variant: 'error',
									})
								);
							}
						})
						.finally(() => setIsLoading(false));
				})
				.catch(() => {
					setIsLoading(false);
					dispatch(Actions.showMessage({ message: 'Failed to upload image', variant: 'error' }));
				});
		} else {
			setIsLoading(true);
			form.thumb = null;
			form.photo = null;
			form.room_id = id;
			addSchedule(form)
				.then((resp) => {
					dispatch(
						Actions.showMessage({
							message: resp.data.message,
							autoHideDuration: 1500,
							variant: 'success',
						})
					);
					navigate(-1);
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
					} else {
						dispatch(
							Actions.showMessage({
								message: err.response.data.message,
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					}
				})
				.finally(() => setIsLoading(false));
		}
	};
	const handleGoBack = () => {
		navigate(-1);
	};
	return (
		<div className="px-64 py-60 mb-64">
			<PageHeader onBack={handleGoBack} title="Add Activity" />

			<div className="bg-white p-60 mt-20 rounded-12 shadow-lg">
				<span className="div-heading">
					<h2 className="" style={{ color: '#06071D', fontWeight: '700', fontSize: '18px' }}>
						Activity Information
					</h2>
				</span>

				<div className="addscheduleform">
					<div className="grid grid-cols-2 mt-32" style={{ gap: 40 }}>
						<span className="insert-form margin-bottom">
							<CustomTimePicker
								disabled={false}
								errTxts={errTxts}
								handleTimeChange={handleTimeChange}
								label="Start Time"
								name="start_time"
								setValue={setStartTime}
								value={startTime}
								width="91%"
							/>
						</span>
						<span className="insert-form margin-bottom">
							<CustomTimePicker
								disabled={false}
								errTxts={errTxts}
								handleTimeChange={handleTimeChange}
								label="End Time"
								name="end_time"
								setValue={setEndTime}
								value={endTime}
								width="91%"
							/>
						</span>
						<span className="insert-form margin-bottom input-subject">
							<TextField
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<div
												className="row-span-2"
												style={{
													justifySelf: 'center',
													marginBottom: '2px',
													paddingLeft: '10px',
												}}
											>
												{preview ? (
													<>
														<Avatar src={preview} style={{ width: 30, height: 30, marginBottom: '10px' }} />
														<div className="cross" onClick={() => setSelectedFile(null)}>
															x
														</div>
													</>
												) : (
													<>
														<input
															className="hidden"
															id="image"
															name="image"
															onChange={onSelectFile}
															ref={inputRef}
															type="file"
														/>
														<button className="btn-image" onClick={() => inputRef.current.click()} type="button">
															upload image
														</button>
													</>
												)}
											</div>
										</InputAdornment>
									),
								}}
								className="w-11/12 "
								error={!!errTxts.subject}
								helperText={errTxts.subject}
								label="Subject"
								name="subject"
								onChange={handleChange}
							/>
						</span>
						<span className="insert-form margin-bottom">
							<TextField
								className="w-11/12"
								error={!!errTxts.type}
								helperText={errTxts.type}
								label="Activity Type"
								name="type"
								onChange={handleChange}
							/>
						</span>
					</div>
				</div>

				{isLoading ? (
					<div className="flex justify-center my-24">
						<CircularProgress className="mx-auto" />
					</div>
				) : (
					<div className="flex justify-center w-max my-24" style={{ gap: '20px' }}>
						<CustomButton
							fontSize="15px"
							onClick={() => {
								navigate(-1);
							}}
							variant="secondary"
							width="140px"
						>
							Cancel
						</CustomButton>

						<CustomButton
							fontSize="15px"
							onClick={() => {
								handleSubmit();
							}}
							variant="primary"
							width="140px"
						>
							Submit
						</CustomButton>
					</div>
				)}
			</div>
		</div>
	);
};

export default Addschedules;
